import {createReducer} from '@reduxjs/toolkit';
import {unionWith, isEqual} from 'lodash';
import {getLastView, updateLastView} from './actions';
import {ViewDto} from '../../../dto/ViewDto';

const initialState: ViewDto[] = [];

export const lastView = createReducer(initialState, (builder) =>
    builder
        .addCase(getLastView.fulfilled, (state, action) => ({
            ...state,
            lastView: unionWith(state, action.payload, isEqual)
        }))
        .addCase(updateLastView.fulfilled, (state, action) => ({
            ...state,
            lastView: state.map((el) => {
                if (el.id === action.payload) {
                    return {...el, new: false};
                } else {
                    return el;
                }
            })
        }))
);
